module.exports = __webpack_public_path__ + "static/media/Psiem.d2ad155f.png";